import * as React from 'react';

import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ToggleButtonProps extends Omit<ButtonProps, 'variant' | 'size'> {
  pressed?: boolean;
}

export const ToggleButton = ({
  pressed = false,
  className,
  children,
  ref,
  ...props
}: ToggleButtonProps & { ref?: React.Ref<HTMLButtonElement> }) => {
  return (
    <Button
      ref={ref}
      type="button"
      variant="outline-neutral"
      size="sm"
      aria-pressed={pressed}
      className={cn(
        'h-9 max-w-80 min-w-0 truncate leading-5 transition-none',
        pressed
          ? 'border-informational bg-highlight-background text-informational hover:bg-highlight-background/50'
          : 'text-foreground hover:text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
};
